import store from '@/store';
import { computedPbxPlans } from "@/common/service/computers/plans/pbx";
import { PLAN_CHANGE_TYPE } from '@/common/service/validate/downsell';

/**
 * Key Sort
 * @param obj
 * @returns {{}}
 */
export const sortObjectByKeys = (obj) => {
  const sortedKeys = Object.keys(obj).sort();
  const sortedObj = {};
  for (const key of sortedKeys) {
    sortedObj[key] = obj[key];
  }
  return sortedObj;
};
/**
 * Compare tuples
 * @param oldTuples
 * @param newTuples
 * @returns {number} 1:up 0: noChange -1:down
 */
export const compareDataSets = (oldTuples, newTuples) => {
  // Array to Obj
  const dictOld = sortObjectByKeys(Object.fromEntries(oldTuples || []));
  const dictNew = sortObjectByKeys(Object.fromEntries(newTuples || []));
  // Same scenes
  if (JSON.stringify(dictOld) === JSON.stringify(dictNew)) {
    return PLAN_CHANGE_TYPE.NO_CHANGE;
  }

  // Down scenes , The number decreases and the key decreases
  for (const key in dictOld) {
    if (!(key in dictNew) || dictOld[key] > dictNew[key]) {
      return PLAN_CHANGE_TYPE.DOWN;
    }
  }
  //Up scenes
  return PLAN_CHANGE_TYPE.UP;
};
export const checkZpUpOrDown = () => {
  const { boughtPlans, getSelectedPlans } = store.getters;
  const oldPlanList = formatData(computedPbxPlans(boughtPlans));
  const willPlanList = formatData(computedPbxPlans(getSelectedPlans));
  return compareDataSets(oldPlanList, willPlanList);
};
export const formatData = (list) => {
  return list.map(item => ([item.plan_code, item.cartInfo.selected_number])) || [];
}

export function enableZoomRadioTabNavigation() {
  function getFocusableInForm() {
    try {
      return Array.from(
        document.querySelectorAll(
          'input[type="radio"].zbo-radio__original, button, a[href], [tabindex]:not([tabindex="-1"])'
        )
      ).filter(
        el =>
          !el.disabled &&
          el.offsetParent !== null &&
          getComputedStyle(el).visibility !== 'hidden'
      );
    } catch (err) {
      console.warn('Failed to get focusables:', err);
      return [];
    }
  }

  function handleKeyDown(e) {
    try {
      if (e.key !== 'Tab') return;

      const focusables = getFocusableInForm();
      const currentIndex = focusables.findIndex(el => document.activeElement === el);

      if (currentIndex === -1) return;

      const isLast = !e.shiftKey && currentIndex === focusables.length - 1;
      const isFirst = e.shiftKey && currentIndex === 0;

      if (isLast || isFirst) {
        return;
      }

      e.preventDefault();
      const nextIndex = currentIndex + (e.shiftKey ? -1 : 1);
      focusables[nextIndex].focus();
    } catch (err) {
      console.warn('Tab navigation error:', err);
    }
  }

  try {
    document.addEventListener('keydown', handleKeyDown);
  } catch (err) {
    console.warn('Failed to initialize:', err);
  }

  return () => {
    try {
      document.removeEventListener('keydown', handleKeyDown);
    } catch (err) {
      console.warn('Failed to remove listener:', err);
    }
  };
}










